import React from "react";

const Contactinfo = () => {
  return (
    <div>
      <div className="container mt-5">
        {/* Top Info Cards */}
        <div className="row text-center mb-5 ms-lg-5 me-lg-5">
          <div className="col-md-4 mb-4">
            <div className="p-4 bg-white rounded shadow-sm">
              <div className="mb-3">
                <div
                  className="d-inline-flex justify-content-center align-items-center bg-primary rounded-circle"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="bi bi-geo-alt-fill text-white fs-4"></i>
                </div>
              </div>
              <p className="mb-0">
                B13, HIG Duplex BDA Colony, RBI Colony, Baramunda, Bhubaneswar,
                Odisha 751003.
              </p>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="p-4 bg-white rounded shadow-sm">
              <div className="mb-3">
                <div
                  className="d-inline-flex justify-content-center align-items-center bg-primary rounded-circle"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="bi bi-envelope-fill text-white fs-4"></i>
                </div>
              </div>
              <p className="mb-0">info.orthospinecare@gmail.com</p>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="p-4 bg-white rounded shadow-sm">
              <div className="mb-3">
                <div
                  className="d-inline-flex justify-content-center align-items-center bg-primary rounded-circle"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="bi bi-telephone-fill text-white fs-4"></i>
                </div>
              </div>
              <p className="mb-0">+91 7873366631<br/>+91 7873366632 </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contactinfo;
